<template>
    <div class="wlx-apply-table-wrapper">
        <div class="basic-head-main" :style="{ backgroundImage: 'url(' + headBg + ')' }">
            <div class="basic-head-con">
                <div class="head-title-con clearfix">
                    <div class="fl basic-book-img-con">
                        <img src="~assets/images/basic-book-img.png" alt />
                    </div>
                    <div class="fr head-title-word">
                        <p class="p-title-1">培训报名表</p>
                        <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-table-content">
            <el-form :model="form" :rules="rules" ref="form">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td class="u-label-title">姓名</td>
                        <td colspan="2">
                            <el-input v-model="form.name"></el-input>
                        </td>
                        <td class="u-label-title">性别</td>
                        <td colspan="2">
                            <el-select v-model="form.sex" placeholder="请选择" class="train-select-con">
                                <el-option label="男" :value="0"></el-option>
                                <el-option label="女" :value="1"></el-option>
                            </el-select>
                        </td>
                        <td colspan="2" class="u-label-title">手机号</td>
                        <td colspan="2">
                            <el-input v-model="form.phoneNum"></el-input>
                        </td>
                        <td colspan="3" rowspan="4" width="160px">
                            <avatarUpload :url="urlAliyunOSS" :files.sync="form.avatar" :minWidth="200" :minHeight="256" :minSize="51200" format="image" :isShowTip="showTip" class="train-sing-up-avatar-con"></avatarUpload>
                        </td>
                    </tr>
                    <tr>
                        <td class="u-label-title">邮箱</td>
                        <td colspan="2">
                            <el-input v-model="form.email"></el-input>
                        </td>
                        <td class="u-label-title">发票抬头</td>
                        <td colspan="2">
                            <el-input v-model="form.invoice"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">纳税人识别号</td>
                        <td colspan="2">
                            <el-input v-model="form.payTaxes"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="u-label-title">职务</td>
                        <td colspan="2">
                            <el-input v-model="form.post"></el-input>
                            <!-- <el-select placeholder="请选择职务" v-model="form.post">
                                <el-option label="校领导" value="校领导"></el-option>
                                <el-option label="院系领导" value="院系领导"></el-option>
                                <el-option label="专业负责人" value="专业负责人"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select> -->
                        </td>
                        <td class="u-label-title">单/合住</td>
                        <td colspan="2">
                            <el-select v-model="form.liveWay" placeholder="请选择" class="train-select-con">
                                <el-option label="单住" :value="1"></el-option>
                                <el-option label="合住" :value="2"></el-option>
                            </el-select>
                        </td>
                        <td colspan="2" class="u-label-title">付款方式</td>
                        <td colspan="2">
                            <el-select v-model="form.payWay" placeholder="请选择" class="train-select-con">
                                <el-option label="公对公汇款" :value="1"></el-option>
                                <el-option label="现场刷卡" :value="2"></el-option>
                                <el-option label="微信支付（线上培训）" :value="3"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="u-label-title">身份证号</td>
                        <td colspan="4">
                            <el-input v-model="form.IDNum"></el-input>
                        </td>
                        <td class="u-label-title">学校</td>
                        <td colspan="4">
                            <el-input v-model="form.school"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">地址</td>
                        <td colspan="11">
                            <el-input v-model="form.address"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">培训需求</td>
                        <td colspan="11">
                            <el-input type="textarea" v-model="form.notes"></el-input>
                        </td>
                    </tr>
                </table>
            </el-form>
            <p class="p-sign-up-tip p-sign-up-tip-1">备注：发票抬头及纳税人识别号务必正确填写，以便开具发票。</p>
            <div class="submit-btn">
                <el-button type="primary" @click="fanhui">返回</el-button>
                <el-button type="primary" @click="submitTable('form')" :disabled="isSubmit">提交</el-button>
            </div>
        </div>
        <!-- 是否填写提示弹框 -->
        <el-dialog title="提示" :visible.sync="IsTipsDialog" :close-on-click-modal="false" width="600px">
            <div class="wlx-is-fill-signUp-con">
                <p>
                    <span>
                        您是否已参与报名？如已参与，您可以
                        <router-link :to="target" v-if="userInfo.code > 0">直接进入</router-link>
                        <a style="color:blue;cursor:pointer;" @click="Gologin()" v-if="userInfo.code < 0">直接进入</a>
                        后台编辑相关信息
                    </span>
                </p>
                <p class="p-name-pass-tip-con">* 用户名为申请人手机号,初始密码为手机号的后6位</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="IsTipsDialog = false">取 消</el-button>
            </span>
        </el-dialog>
        <newLogin :isShow="showObject"></newLogin>
    </div>
</template>

<script>
import avatarUpload from "components/avatarUpload.vue";
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import Bus from "components/bus.js";
import newLogin from "components/newLogin.vue";
export default {
    data() {
        return {
            urlAliyunOSS: "/api/design/osssign/getsign",
            headBg: require("assets/images/wlx-baic-bg-img.png"),
            form: {
                avatar: "",
                name: "",
                school: "",
                IDNum: "",
                sex: "",
                post: "",
                phoneNum: "",
                email: "",
                address: "",
                invoice: "",
                payTaxes: "",
                liveWay: "",
                payWay: "",
                notes: "",
            },
            timer: "",
            IsTipsDialog: true,
            showObject: {
                isShow: false,
            },
            isSubmit: false,
            rules: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            },
            showTip: true,
        };
    },
    props: {
        signUpId: {
            type: String,
            default: "",
        },
        planId: {
            type: String,
            default: "",
        },
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        association: function() {
            return this.$store.state.association;
        },
        target: function() {
            let Urlname = "";
            if (this.$store.state.auth.userType === 1) {
                Urlname = "stuBasicInfo";
            } else if (this.$store.state.auth.userType === 2) {
                Urlname = "teaPilotManager";
            } else if (this.$store.state.auth.userType === 3) {
                Urlname = "siteBasicInfo";
            } else if (this.$store.state.auth.userType === 5) {
                Urlname = "managerIndex";
            }
            return { name: Urlname };
        },
    },
    components: {
        avatarUpload,
        newLogin,
    },
    created() {},
    methods: {
        fanhui() {
            this.$router.go(-1);
        },
        submitTable(formName) {
            var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
            if (this.form.name == "") {
                this.$message({
                    message: "请输入姓名",
                    type: "warning",
                });
                return false;
            }
            if (this.form.sex === "") {
                this.$message({
                    message: "请选择性别",
                    type: "warning",
                });
                return false;
            }

            if (this.form.phoneNum == "") {
                this.$message({
                    message: "请输入号码",
                    type: "warning",
                });
                return false;
            } else if (!reg.test(this.form.phoneNum)) {
                this.$message({
                    message: "手机号格式不正确",
                    type: "warning",
                });
                return false;
            }
            if (this.form.email == "") {
                this.$message({
                    message: "请输入邮箱",
                    type: "warning",
                });
                return false;
            }
            if (this.form.school == "") {
                this.$message({
                    message: "请输入学校",
                    type: "warning",
                });
                return false;
            }
            if (this.form.invoice == "") {
                this.$message({
                    message: "请输入发票抬头",
                    type: "warning",
                });
                return false;
            }
            if (this.form.avatar == "") {
                this.$message({
                    message: "请上传头像",
                    type: "warning",
                });
                return false;
            }
            if (this.form.payTaxes == "") {
                this.$message({
                    message: "请输入纳税人识别号",
                    type: "warning",
                });
                return false;
            }
            if (this.form.IDNum == "") {
                this.$message({
                    message: "请输入身份证号",
                    type: "warning",
                });
                return false;
            }
            if (this.form.post == "") {
                this.$message({
                    message: "请输入职务",
                    type: "warning",
                });
                return false;
            }
            if (this.form.address == "") {
                this.$message({
                    message: "请输入地址",
                    type: "warning",
                });
                return false;
            }
            if (this.form.liveWay == "") {
                this.$message({
                    message: "请选择单/合住",
                    type: "warning",
                });
                return false;
            }
            if (this.form.payWay == "") {
                this.$message({
                    message: "请选择付款方式",
                    type: "warning",
                });
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isSubmit = true;
                    this.$http
                        .post("/api/XOrg/PeiXun/addPeiXun", {
                            activityId: this.signUpId,
                            planId: this.planId,
                            Name: this.form.name,
                            Sex: this.form.sex,
                            IDNum: this.form.IDNum,
                            SchoolTitle: this.form.school,
                            Photo: this.form.avatar,
                            Post: this.form.post,
                            Phone: this.form.phoneNum,
                            Email: this.form.email,
                            Address: this.form.address,
                            Invoice: this.form.invoice,
                            TaxNumber: this.form.payTaxes,
                            PaymentType: this.form.payWay,
                            StayType: this.form.liveWay,
                            Note: this.form.notes,
                        })
                        .then((res) => {
                            if (res.code > 0) {
                                const h = this.$createElement;
                                this.$message({
                                    message: h("div", null, [
                                        h("p", null, [h("span", { style: "color: #000" }, "报名成功，可登陆"), h("span", { style: "color: red" }, res.username), h("span", { style: "color: #000" }, "账号进行修改管理")]),
                                        h("p", null, [h("span", { style: "color: #000" }, "默认密码为手机号后六位"), h("span", { style: "color: red" }, res.password), h("span", { style: "color: #000" }, "即将跳转到管理系统...")]),
                                    ]),
                                    type: "success",
                                    duration: 5000,
                                });

                                this.timer = setTimeout(this.goclpp, 5000);
                            } else {
                                this.isSubmit = false;
                                this.$message({
                                    message: res.msg,
                                    type: "warning",
                                });
                            }
                        });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                    return false;
                }
            });
        },
        goclpp() {
            this.$router.push({
                name: "TeaPeiXunEnrollManager",
            });
        },
        Gologin() {
            this.IsTipsDialog = false;
            this.showObject = {
                isShow: true,
            };
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
};
</script>

<style lang="scss">
.wlx-apply-table-wrapper {
    height: 100%;
    overflow: auto;
    background: #f0f6ff;
    .basic-head-main {
        height: 706px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center top;
        .basic-head-con {
            margin: 0 auto;
            width: 1000px;
        }
        .head-logo-con {
            padding: 26px 0 0 26px;
        }
        .logo-img-val {
            height: 40px;
        }
        .head-title-con {
            position: relative;
            padding-top: 40px;
        }
        .basic-book-img-con {
            margin-left: 10px;
        }
        .head-title-word {
            position: absolute;
            right: 0;
            top: 80px;
            z-index: 100;
            color: #fff;
        }
        .p-title-1 {
            font-size: 55px;
            font-weight: bold;
            text-align: center;
        }
        .p-title-2-1 {
            margin-top: 50px;
            text-align: right;
            font-size: 20px;
        }
    }
    .apply-table-content {
        margin: -325px auto 0;
        padding: 20px 0;
        padding-top: 50px;
        width: 1000px;
        background: #fff;
    }
    .p-down-applyTable-btn {
        text-align: right;
        color: #0365f5;
        padding: 0 22px 20px 0;
        cursor: pointer;
        font-size: 17px;
    }
    .apply-table-title {
        padding: 20px 0;
        text-align: center;
    }
    .submit-apply-btn {
        padding: 20px 0;
        text-align: center;
    }
    .label-job-con {
        padding: 0 20px;
    }
    table {
        margin: 0 auto;
        width: 960px;
        border-right: 1px solid #999;
        border-bottom: 1px solid #999;
        table-layout: fixed;
        word-break: break-all;
        background: #f0f0f0;
    }
    .u-label-title {
        font-weight: bold;
    }
    .demo-table {
        margin-top: 100px;
    }
    .expert-certify-ul {
        height: 100%;
    }
    .expert-certify-li {
        width: 25%;
    }
    .certify-li-cell {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
    }
    .certify-li-cell-num {
        border-top: none;
    }
    .fistCertify {
        .certify-li-cell {
            border-left: none;
        }
    }
    .el-textarea__inner,
    .el-input__inner {
        border: none;
        font-size: 16px;
        color: #000;
    }
    .input-edu .el-input__inner {
        height: 82px;
        line-height: 82px;
    }
    .el-textarea__inner:focus {
        border: none;
    }
    .el-input__inner:focus {
        border: none;
    }
    .el-date-editor.el-input {
        width: 100%;
    }
    table td {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
        text-align: center;
    }
    .label-opinion-title {
        padding: 10px;
        text-align: left;
    }
    .sp-mark-label {
        color: red;
    }
    .h4-major-title {
        padding: 10px 0;
    }
    td {
        height: 40px;
        // width: 76.9px;
        font-size: 16px;
    }
    .train-select-con {
        width: 100%;
    }
    .p-sign-up-tip {
        padding: 10px 0 0 20px;
    }
    .p-sign-up-tip-1 {
        margin-top: 40px;
    }
    .submit-btn {
        padding: 20px 0;
        text-align: center;
    }
    .wlx-is-fill-signUp-con {
        font-size: 16px;
        .p-name-pass-tip-con {
            margin-top: 10px;
            color: red;
        }
    }
    .train-sing-up-avatar-con {
        .el-upload-list--picture-card {
            .el-upload-list__item-thumbnail {
                width: auto;
            }
        }
    }
}
</style>
